import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import User from 'models/User';

import { profileGet } from 'store/modules/user/actions';
import { State as ReduxState } from 'store/state';

import Component from './component';

export interface Props extends ParentProps {
    state?: {
        user?: User;
        authToken?: string;
    };
    actions?: {
        profileGet: Function;
    }
}

export interface ParentProps {
    jobId: string;
    cityId?: string;
    disabled?: boolean;
    iconOnly?: boolean;
}

const mapStateToProps = (state: ReduxState, ownProps?: Props): object => {
    return {
        state: {
            user: state.user.profile,
            authToken: state.user.authToken,
        },
    };
};

const mapDispatchToProps = (dispatch: Dispatch): object => {
    return {
        actions: {
            profileGet: bindActionCreators(profileGet, dispatch),
        },
    };
};

Component.defaultProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(Component);